type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
};

export function ScreenIcon({ width = 12, height = 12, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1C5.6548 1 5.375 1.27982 5.375 1.625V2H2C1.44771 2 1 2.44772 1 3V8.5C1 9.0523 1.44771 9.5 2 9.5H3.10509L2.44513 10.6466C2.27292 10.9457 2.37584 11.3278 2.67499 11.5C2.93675 11.6507 3.26203 11.5907 3.45462 11.3729C3.48213 11.3418 3.50694 11.3076 3.52847 11.2702L4.5474 9.5H7.4776L8.49655 11.2702C8.66875 11.5693 9.05085 11.6722 9.35 11.5C9.64915 11.3278 9.75205 10.9457 9.57985 10.6466L8.9199 9.5H10C10.5523 9.5 11 9.0523 11 8.5V3C11 2.44772 10.5523 2 10 2H6.625V1.625C6.625 1.27982 6.3452 1 6 1ZM7.6161 4.75L6.75 5.6161L5.69195 4.55806C5.57475 4.44085 5.41575 4.375 5.25 4.375C5.08425 4.375 4.92527 4.44085 4.80805 4.55805L3.5 5.8661C3.25592 6.1102 3.25592 6.5059 3.5 6.75C3.74408 6.9941 4.13981 6.9941 4.38388 6.75L5.25 5.8839L6.30805 6.94195C6.42525 7.05915 6.5842 7.125 6.75 7.125C6.91575 7.125 7.0747 7.05915 7.19195 6.94195L8.5 5.6339C8.74405 5.3898 8.74405 4.99408 8.5 4.75C8.2559 4.50592 7.8602 4.50592 7.6161 4.75Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default ScreenIcon;
